import { render, staticRenderFns } from "./ReportPlayerOutstandingPaginationComponent.vue?vue&type=template&id=2d5723e7&"
import script from "./ReportPlayerOutstandingPaginationComponent.vue?vue&type=script&lang=js&"
export * from "./ReportPlayerOutstandingPaginationComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReportPlayerOutstandingPaginationComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports